module.exports = __webpack_public_path__ + "img/index-4-pic01_1@2x.e56752d0.png";